<template>
  <div>
    <Report
      module="Operacional"
      name="Saídas e Retornos"
      urlGet="/api/v1/operational/report/delivery-devolution"
      :header="header"
      :filters="filters"
    />
  </div>
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportDeliveryDevolutionView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Dt Cadastro",
          field: "registeredDate",
          fieldOrderBy: "RegisteredDate",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 120px; white-space: nowrap;",
        },
        {
          title: "Número",
          field: "number",
          fieldOrderBy: "Number",
          show: true,
          styleHeader: "width:70px; text-align:center;",
          styleBody: "max-width: 70px; white-space: nowrap; text-align:center;",
        },
        {
          title: "Identificação",
          field: "identification",
          fieldOrderBy: "Identification",
          show: true,
          styleHeader: "width:150px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; font-style: italic;",
        },
        {
          title: "Consultor",
          field: "collaboratorName",
          fieldOrderBy: "CollaboratorName",
          show: false,
          styleHeader: "width:150px;",
          styleBody: "max-width: 150px; white-space: nowrap;",
        },
        {
          title: "Razão Social/Nome",
          field: "companyName",
          fieldOrderBy: "CompanyName",
          show: true,
          styleHeader: "width:250px;",
          styleBody: "max-width: 250px; white-space: nowrap;",
        },
        {
          title: "Fantasia/Apelido",
          field: "tradeName",
          fieldOrderBy: "TradeName",
          show: true,
          styleHeader: "width:150px;",
          styleBody: "max-width: 150px; white-space: nowrap;",
        },
        {
          title: "Contato",
          field: "contactName",
          fieldOrderBy: "ContactName",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 120px; white-space: nowrap;",
        },
        {
          title: "Tipo",
          field: "typeName",
          fieldOrderBy: "TypeName",
          show: true,
          styleHeader: "width:120px;",
          styleBody: "max-width: 120px; white-space: nowrap;",
        },
        {
          title: "Período",
          field: "deliveryDevolutionStr",
          fieldOrderBy: "DeliveryDevolution",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:130px;",
          styleBody: "max-width: 130px; white-space: nowrap;",
        },
        {
          title: "Realizado",
          field: "doneName",
          fieldOrderBy: "DoneName",
          show: true,
          styleHeader: "width:120px; text-align:center;",
          styleBody: "max-width: 120px; white-space: nowrap; text-align:center;",
        },
      ],
      filters: [
        {
          type: "date",
          title: "Período",
          field: "DeliveryDevolution",
          value: "",
          required: true,
        },
        {
          type: "text",
          title: "Identificação",
          field: "Identification",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Consultor",
          field: "CollaboratorName",
          url: "/api/v1/human-resources/collaborator/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Cliente",
          field: "CompanyName",
          url: "/api/v1/crm/customer/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "options",
          title: "Tipo",
          field: "Type",
          options: [
            { text: "Saída", value: 1 },
            { text: "Retorno", value: 2 },
          ],
          value: [],
        },
        {
          type: "options",
          title: "Realizado",
          field: "Done",
          options: [
            { text: "Sim", value: true },
            { text: "Não", value: false },
          ],
          value: [],
        },
      ],
    };
  },
};
</script>
